
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import "../styles/descrecibo.css"

const DescargaRecibo = ({ recibo, userLegajo }) => {
    const [mes, anio] = recibo.Mes.split('/');
    const legajoFormateado = userLegajo.toString().padStart(4, '0');
    const secuencia = recibo.Secuencia; 
    const fileBase = `${anio}${mes}${secuencia}O${legajoFormateado}`;
    
    // Usar endpoint del backend - solo mes sin año
    const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');
    const pdfPath = `${API_URL}/api/recibos/${mes}/${secuencia}/${userLegajo}/pdf`;

    const handleDescarga = () => {
        // Abrir en nueva ventana con token en la URL o usar fetch para descargar
        const token = localStorage.getItem('token');
        
        // Crear un enlace temporal con el token
        fetch(pdfPath, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            // Liberar el objeto URL después de un tiempo
            setTimeout(() => window.URL.revokeObjectURL(url), 100);
        })
        .catch(error => {
            console.error('Error al descargar:', error);
            alert('Error al descargar el recibo');
        });
    };

    return (
        <Button 
            className="btn btn-descargar action-btn"
            size="sm"
            onClick={handleDescarga}
            title="Descargar recibo"
        >
            <FaDownload />
        </Button>
    );
};

export default DescargaRecibo;